import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IStudentEnrollment, IStudentEnrollments, IStudent, IStudents } from '../interfaces/student';
import { IClass } from '../interfaces/class';

@Injectable({
  providedIn: 'root',
})
export class StudentService {
  constructor(private httpClient: HttpClient) {}

  getStudents(url: string, filters: any): Observable<IStudents> {
    return this.httpClient.get<IStudents>(url, {
      headers: { accept: '*/*' },
      params: filters,
    }) as Observable<IStudents>;
  }

  getStudentEnrollments(url: string, filters: any): Observable<IStudentEnrollments> {
    return this.httpClient.get<IStudentEnrollments>(url, {
      headers: { accept: '*/*' },
      params: filters,
    }) as Observable<IStudentEnrollments>;
  }

  getStudentEnrollmentById(url: string): Observable<IStudentEnrollment> {
    return this.httpClient.get<IStudentEnrollment>(url, { headers: { accept: '*/*' } }) as Observable<IStudentEnrollment>;
  }

  getStudentById(url: string): Observable<IStudent> {
    return this.httpClient.get<IStudent>(url, { headers: { accept: '*/*' } }) as Observable<IStudent>;
  }

  editStudent(url: string, classForm: any): Observable<IStudent> {
    return this.httpClient.patch<IStudent>(url, classForm, {
      headers: { accept: '*/*' },
    }) as Observable<IStudent>;
  }

  editClassStudent(url: string, classForm: any): Observable<IStudentEnrollment> {
    return this.httpClient.patch<IStudentEnrollment>(url, classForm, {
      headers: { accept: '*/*' },
    }) as Observable<IStudentEnrollment>;
  }

  createStudent(url: string, classForm: any): Observable<any> {
    return this.httpClient.post<any>(url, classForm, {
      headers: { accept: '*/*' },
    }) as Observable<any>;
  }
}
